module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-up"
  }, [_c('section', {
    staticClass: "left-panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4 vertical-centre"
  }, [(!_vm.added) ? _c('div', {
    staticClass: "left-panel-centre"
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "large",
    staticStyle: {
      "font-size": "1.28em",
      "padding-bottom": "13px"
    }
  }, [_vm._v("The first ever matching platform for people passionate about African development.")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "color": "#1ba4db",
      "font-family": "'Apercu-medium', sans-serif"
    }
  }, [_vm._v("Sign up for early access:")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.register($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.email),
      expression: "email",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "email",
      "placeholder": "someone@example.com",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-big bg-two active",
    staticStyle: {
      "background-position": "center 553px"
    },
    attrs: {
      "type": "submit",
      "value": "Yes, I'm In!"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#7B7E80",
      "opacity": "0.6",
      "position": "relative",
      "top": "16px"
    }
  }, [_vm._v("We promise to never spam you!")])])]) : (_vm.added) ? _c('div', {
    staticClass: "left-panel-centre"
  }, [_c('h1', {
    staticClass: "small"
  }, [_c('span', [_vm._v("Thanks!")]), _vm._v(" We'll email you when our registration process opens.")])]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "bottom"
  }, [_c('h3', {
    staticStyle: {
      "color": "#1ba4db"
    }
  }, [_vm._v("#BigIdeasforAfrica")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link blue",
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("About PEI exChange")])], 1)])])]), _vm._v(" "), _c('section', {
    staticClass: "hero-image"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "grid-container top"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/images/global/logo.svg")
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('span', {
    staticStyle: {
      "color": "#1ba4db"
    }
  }, [_vm._v("Join us as we build "), _c('br'), _c('span', {
    staticStyle: {
      "color": "#00AE8F"
    }
  }, [_vm._v("PEI")]), _vm._v(" ex"), _c('span', {
    staticStyle: {
      "color": "#327CA2"
    }
  }, [_vm._v("Change")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "link blue",
    attrs: {
      "target": "_blank",
      "href": "http://planetearthinstitute.org.uk"
    }
  }, [_vm._v("Visit PEI Website")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6441dc72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 714
// module chunks = 1